import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form'
import { userReducer } from './user-reducer'
import { eventsReducer } from './events-reducer';
import { loadingReducer } from './loading-reducer';
import { tickersReducer } from './tickers-reducer';
import { adminReducer } from './admin-reducer';

const appReducer = combineReducers({
  // add reducers
  tickersReducer,
  userReducer,
  eventsReducer,
  loadingReducer,
  adminReducer,
  form: formReducer
});

const rootReducer = (state, action) => {
  return appReducer(state, action);
}

export default rootReducer;
